<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="flex flex-row">
    <uni-field [label]="fieldName">
      <input pInputText [(ngModel)]="fieldValue"  />
    </uni-field>
   </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button pButton type="button" class="p-button-raised" *ngFor="let buttonName of buttons, let i=index" (click)="select(i)">{{buttons[i]}}</button>
  </div>
</ng-template>
